const isLegislationInitiallySelected = legislation => {
    if (!legislation || legislation.isRequestable === false) {
        return false
    }

    if (typeof legislation.isRequestable === 'undefined') {
        return !!legislation.isApplicable
    }

    return true
}

const getInitiallyUnselectedLegislationIds = legislations => (
    (Array.isArray(legislations) ? legislations : [])
        .filter(legislation => !isLegislationInitiallySelected(legislation))
        .map(legislation => legislation && legislation.id)
        .filter(id => id !== null && typeof id !== 'undefined')
)

export {
    getInitiallyUnselectedLegislationIds,
    isLegislationInitiallySelected,
}
